import MoreVertIcon from '@mui/icons-material/MoreVert';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import MiViewMenu from '../MiViewMenu/MiViewMenu';
import MiViewTooltip from '../MiViewTooltip/MiViewTooltip';
import useMiViewTargetCard from './MiViewTargetCard.hook';
import {
  cardWrapperStyle,
  cepInfoWrapperStyle,
  cepDateBlockStyle,
  percentBlockStyle,
  tacticIconBlockStyle,
  iconListStyle,
  actionOrderBlockStyle,
  iconStyle,
  menuButtonStyle,
  menuIconStyle,
} from './MiViewTargetCard.style';
import { MiViewTargetCardProps } from './MiViewTargetCard.types';

const MiViewTargetCard: FC<MiViewTargetCardProps> = ({ cep, tactics, AEDocuments, IVADocuments, target }) => {
  const { t } = useTranslation();
  const {
    getIconByChannel,
    formatDateToMMDDYYYY,
    targetCardConfig,
    openTooltip,
    handleTooltipOpening,
    handleTooltipClosing,
    formattedTactics,
    getTooltipContent,
  } = useMiViewTargetCard(tactics, AEDocuments, IVADocuments);

  return (
    <Box display="flex" flexDirection="row" sx={ cardWrapperStyle }>
      <Box display="flex" flexDirection="column" width="33%" sx={ cepInfoWrapperStyle }>
        <Box>{ cep?.title }</Box>
        <Box sx={ cepDateBlockStyle }>{ `${formatDateToMMDDYYYY(cep?.dateStart)} - ${formatDateToMMDDYYYY(cep?.dateEnd)}` }</Box>
        <Box sx={ percentBlockStyle }>{ t('maya_miview_percents_label') }</Box>
      </Box>

      {
        <Box display='flex' flexDirection="row" width="60%" sx={ iconListStyle }>
          {
            !!openTooltip.length && formattedTactics?.map((tactic, index) => {
              const TacticIcon = getIconByChannel(tactic?.channel);
              if (!tactic.actionOrder) return null;

              return (
                <MiViewTooltip
                  key={ tactic._id + target.mdmId }
                  open={ openTooltip[index] }
                  handleTooltipClosing={ () => handleTooltipClosing(index) }
                  title={
                    <>
                      {
                        getTooltipContent(tactic).map((row, rowIndex) => (
                          <Box key={ rowIndex }>{ row }</Box>
                        ))
                      }
                    </>
                  }
                  disableHoverListener
                  disableFocusListener
                  disableTouchListener
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    sx={ tacticIconBlockStyle }
                    onClick={ () => handleTooltipOpening(index) }
                  >
                    <Box sx={ actionOrderBlockStyle }>{ tactic.actionOrder }</Box>
                    <TacticIcon sx={ iconStyle }></TacticIcon>
                  </Box>
                </MiViewTooltip>
              );
            })
          }
        </Box>
      }
      <Box display="flex" flexDirection="row" justifyContent="left" alignItems="center">
        <MiViewMenu
          menuList={ targetCardConfig.menuList }
          buttonStyle={ menuButtonStyle }
          tooltipMessage={ t('maya_miview_menu_action_tooltip') }
        >
          <MoreVertIcon sx={ menuIconStyle }/>
        </MiViewMenu>
      </Box>
    </Box>
  );
};

export default MiViewTargetCard;
